export default {
  'application-guider': 'User Guide',
  'application-title': 'Your Applications Suite',
  'documents.guider': 'User Guide',
  'documents.system-directory': 'System Directory',
  'documents.docs': 'User Guide Documents',
  'documents.empty': 'Empty Document',
};
